export default {
  parent: [-2, "", -3],
  box: [2, "", 3]
};
